module.exports = __webpack_public_path__ + "img/default_banner.d119ce47.png";